import Vue from "vue";
import Vuex from "vuex";
import profile from "./modules/profile";
import doctor from "./modules/doctor";
import cases from "./modules/cases";
import patient from "./modules/patient";
import note from "./modules/note";
import recommendation from "./modules/recommendation";
import medication from "./modules/medication";
import consultation from "./modules/consultation";
import diagnosis from "./modules/diagnosis";
import medicine from "./modules/medicine";
import examination from "./modules/examination";
import request from "./modules/request";
import user from "./modules/user";
import eligibility from "./modules/eligibility";
import specialization from "./modules/specialization";
import pms from "./modules/pms";
import allergy from "./modules/allergy";
import chat from "@/views/csr/store/modules/chat";
import notification from "@/views/csr/store/modules/notification";
import schedule from './modules/schedule';
import patientStoreModule from "@/views/csr/store/modules/patient";
import password from './modules/password'
import ror from './modules/ror'
import vtt from './modules/vtt';
import textreplacement from "./modules/textreplacement";

Vue.use(Vuex);

/* eslint-disable no-new */
const store = new Vuex.Store({
  strict: true,
  modules: {
    profile,
    doctor,
    cases,
    patient,
    note,
    recommendation,
    medication,
    consultation,
    diagnosis,
    medicine,
    examination,
    request,
    user,
    eligibility,
    specialization,
    pms,
    allergy,
    chat,
    notification,
    schedule,
    csrPatient: patientStoreModule,
    password,
    ror,
    vtt,
    textreplacement
  },
});

export default store;
